export default __webpack_public_path__ + "static/media/uploader-abbottLibre-3.81a043b0.png";